import { useState } from "react";
import { Paperclip } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Small pill-button that fetches a receipt (auth-safe blob) and opens it in a new tab.
// Renders nothing when receipt is falsy.
export default function ReceiptLink({ receipt, testId, label = "Recibo", className = "" }) {
  const [busy, setBusy] = useState(false);
  if (!receipt || !receipt.path) return null;

  const open = async (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    setBusy(true);
    try {
      const res = await api.get(`/receipts/${receipt.path}`, { responseType: "blob" });
      const blob = new Blob([res.data], { type: receipt.content_type || "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={open}
      disabled={busy}
      data-testid={testId}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded font-mono text-[10px] font-bold border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 transition-colors ${className}`}
    >
      <Paperclip className="w-3 h-3" /> {busy ? "…" : label}
    </button>
  );
}
